import { TextField } from '@hulu/react-style-components';
import React, { BaseSyntheticEvent, useState } from 'react';

import { ReactComponent as ClosedEye } from '../../assets/images/closedEye.svg';
import { ReactComponent as OpenedEye } from '../../assets/images/openedEye.svg';
import InputLabel from '../InputLabel';
import { StyledContent, StyledEyeWrapper } from './styled';

type Props = {
  name: string;
  labelText?: string;
  placeholder?: string;
  errorMessage?: string;
  onChange?: (event: BaseSyntheticEvent) => void;
  onBlur?: (e: React.FocusEvent) => void;
  dataTestId?: string;
  value?: string;
};

type CurrentType = 'text' | 'password';

const PasswordInput = ({
  name,
  labelText,
  placeholder,
  errorMessage = '',
  onChange,
  onBlur,
  dataTestId = 'fieldPasswordInput',
  value,
}: Props): JSX.Element => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const currentType: CurrentType = showPassword ? 'text' : 'password';

  const handleShowPassword = (): void => {
    setShowPassword((current) => !current);
  };

  return (
    <StyledContent>
      <TextField
        label={<InputLabel key={name}>{labelText}</InputLabel>}
        name={name}
        type={currentType}
        placeholder={placeholder}
        errMsg={errorMessage}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        data-testid={dataTestId}
      />
      <StyledEyeWrapper onClick={handleShowPassword}>
        {showPassword ? <OpenedEye data-testid="iconOpenedEye" /> : <ClosedEye data-testid="iconClosedEye" />}
      </StyledEyeWrapper>
    </StyledContent>
  );
};

export default PasswordInput;
